import { jsx } from "react/jsx-runtime";
import { UrlInputFieldWUT } from "../../../ui/url-input-field/url-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const DextUrlInputWUT = (props) => {
  const fieldType = FIELD_TYPES.DEXT_URL_INPUT;
  return /* @__PURE__ */ jsx(UrlInputFieldWUT, { ...props, fieldType });
};
export {
  DextUrlInputWUT
};
//# sourceMappingURL=dext-url-input-wut.js.map
